import { IUserContext } from '@truckdown/systems';
import { ILogData } from './Logs/ILogData';
import { IReportData } from './Analytics/IReportData';
import { IAnalyticsDataBrowser } from './Analytics/IAnalyticsDataBrowser';
import { IAnalyticsManager } from './Analytics/IAnalyticsManager';

export type { DateRange } from './DateRange';
export type { ResultModel } from './ResultModel';

export type { ILogData };
export type { IReportData };
export type { LogEntryQuery } from './Logs/LogEntryQuery';
export type { SystemInfoQuery } from './Logs/SystemInfoQuery';
export type { UserContextQuery } from './Logs/UserContextQuery';

export type { IAnalyticsDataBrowser };
export type { IAnalyticsManager };
export type { AnalyticDataModel } from './Analytics/AnalyticDataModel';
export type { ReverseAnalyticsModel } from './Analytics/ReverseAnalyticsModel';
export type { AnalyticQueryModel } from './Analytics/AnalyticQueryModel';
export { DataPeriod } from './Analytics/DataPeriod';
export type { DrilledAnalyticDataModel } from './Analytics/DrilledAnalyticDataModel';
export type { DrilledAnalyticQueryModel } from './Analytics/DrilledAnalyticQueryModel';
export type { FactDataModel } from './Analytics/FactDataModel';
export type { FleetActivitySummary } from './Analytics/FleetActivitySummary';
export type { VendorDataSummary } from './Analytics/VendorDataSummary';
export type { DimensionQuery } from './Analytics/DimensionQuery';
export type { DrilledQueryModel } from './Analytics/DrilledQueryModel';
export type { DrilledQueryResultModel } from './Analytics/DrilledQueryResultModel';
export * as AnalyticsUtilities from './Analytics/AnalyticsExtensions';

export default function (context: IUserContext): void {
    context.registerService({
        name: 'ILogData',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-analysis-log-data" */ './Logs/LogData');
            return new svc.LogData(context) as ILogData;
        }
    });
    context.registerService({
        name: 'IReportData',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-analysis-report-data" */ './Analytics/ReportData');
            return new svc.ReportData(context) as IReportData;
        }
    });
    context.registerService({
        name: 'IAnalyticsDataBrowser',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-analysis-data-browser" */ './Analytics/AnalyticsDataBrowser');
            return new svc.AnalyticsDataBrowser(context) as IAnalyticsDataBrowser;
        }
    });
    context.registerService({
        name: 'IAnalyticsManager',
        activator: async () => {
            var svc = await import(/* webpackChunkName: "api-analysis-analytics-manager" */ './Analytics/AnalyticsManager');
            return new svc.AnalyticsManager(context) as IAnalyticsManager;
        }
    });
}